import React, { useEffect, useState } from 'react';
import Spinner from '@/presentation/components/Spinner';
import CourseScheduleInfo from './components/CourseScheduleInfo';
import ModuleContainer from '@/presentation/components/Container';
import { SubsectionHeader } from '@/presentation/reusables/SectionHeader';
import EnrollmentTurnAlert from './components/Alert/EnrollmentTurnAlert';
import Container from './styled';
import ButtonFloating from './components/ButtonFloating';
import EmptyDataStateMessage from '@/presentation/reusables/EmptyDataStateMessage';
import { RegistrationShiftProps } from './types';
import { emptyState } from './constants';

const RegistrationShift = ({
  courses,
  isLoading,
  onBack,
  enrollmentTurn,
  headerInformation
}: RegistrationShiftProps) => {
  const { isLoadingAcademic, isLoadingTurn, isLoadingCourses } = isLoading;
  const { title, description } = headerInformation;
  const { textDate, textHour } = enrollmentTurn;

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const updateIsMobile = () => setIsMobile(window.innerWidth < 768);
    updateIsMobile();
    window.addEventListener('resize', updateIsMobile);
    return () => window.removeEventListener('resize', updateIsMobile);
  }, []);

  return (
    <ModuleContainer containerType="section">
      <SubsectionHeader
        title={title}
        description={description}
        onClick={onBack}
      />
      <Container>
        {(isLoadingCourses || isLoadingTurn || isLoadingAcademic) && (
          <Spinner />
        )}
        {!isLoadingCourses && !isLoadingAcademic && !isLoadingTurn && (
          <>
            {textDate.length !== 0 && textHour.length !== 0 && (
              <EnrollmentTurnAlert
                enrollmentTurn={enrollmentTurn}
                isMobile={isMobile}
              />
            )}
            {courses.length === 0 ? (
              <EmptyDataStateMessage message={emptyState} layout="row" />
            ) : (
              <CourseScheduleInfo courses={courses} isMobile={isMobile} />
            )}
          </>
        )}
      </Container>
      {isMobile && <ButtonFloating />}
    </ModuleContainer>
  );
};

export default RegistrationShift;
